import { Question } from './question';

export class QuestionText extends Question{
  
  constructor(object = null){
    super();
    this.type = 'QuestionText';
    this.typeText = "テキスト";

    if(object){
      super.set(object);
      this.set(object);
    }
  };

  set(object){

  }

  static test(){
    const object = {
      hash:"xxxxxxxx",
      title:"業種を選択してください",
    };
    return object;
  }
}
